// extracted by mini-css-extract-plugin
export default {"containerSpinner":"Loader_containerSpinner__xwy5t","spinner":"Loader_spinner__h0pER","rotate":"Loader_rotate__aEbMf","path":"Loader_path__JyRSc","dash":"Loader_dash__SGg1s"};